import { render, staticRenderFns } from "./UsefulMaterials.vue?vue&type=template&id=58ee4bee&scoped=true&"
import script from "./UsefulMaterials.vue?vue&type=script&lang=js&"
export * from "./UsefulMaterials.vue?vue&type=script&lang=js&"
import style0 from "./UsefulMaterials.vue?vue&type=style&index=0&id=58ee4bee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ee4bee",
  null
  
)

export default component.exports